// path: src/Achievements.js
import React from "react";
import "./App.css";

const ACHIEVEMENTS = Array.from({ length: 10 }, (_, index) => {
    const target = (index + 1) * 10;

    return {
        id: `obtain-${target}-corgi-cards`,
        title: `Obtain ${target} Corgi Cards`,
        target,
    };
});

const Achievements = ({ unlockedCount = 0, totalCards = 113, onBackHome }) => {
    return (
        <div className="achievementsScreen">
            <div className="achievementsHeader">
                <div>
                    <h1 className="impactFont achievementsTitle">Achievements</h1>
                    <div className="achievementsProgress">
                        Collection Progress: {unlockedCount}/{totalCards}
                    </div>
                </div>

                <button className="collectionBackButton" onClick={onBackHome}>
                    Home
                </button>
            </div>

            <div
                className="achievementsList"
                role="list"
                aria-label="Achievements"
            >
                {ACHIEVEMENTS.map((achievement) => {
                    const completed = unlockedCount >= achievement.target;
                    const progressValue = Math.min(
                        unlockedCount,
                        achievement.target
                    );
                    const percent = Math.min(
                        100,
                        Math.round((progressValue / achievement.target) * 100)
                    );

                    return (
                        <div
                            className={`achievementItem ${
                                completed
                                    ? "achievementItem--completed"
                                    : "achievementItem--locked"
                            }`}
                            role="listitem"
                            key={achievement.id}
                        >
                            <div className="achievementIcon" aria-hidden="true">
                                🏆
                            </div>

                            <div className="achievementContent">
                                <div className="achievementTopRow">
                                    <div className="achievementName">
                                        {achievement.title}
                                    </div>

                                    <div className="achievementStatus">
                                        {completed ? "Completed" : "Locked"}
                                    </div>
                                </div>

                                <div className="achievementProgressText">
                                    {progressValue}/{achievement.target}
                                </div>

                                <div
                                    className="achievementProgressBar"
                                    aria-label={`${achievement.title} progress`}
                                    aria-valuemin="0"
                                    aria-valuemax={achievement.target}
                                    aria-valuenow={progressValue}
                                    role="progressbar"
                                >
                                    <div
                                        className="achievementProgressBarFill"
                                        style={{ width: `${percent}%` }}
                                    />
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>

            <div className="achievementsHint">
                Achievements unlock automatically as your collection grows.
            </div>
        </div>
    );
};

export default Achievements;